import React from 'react';
import AuthLayout from '@layouts/AuthLayout';
import { LoginForm } from '@/components/forms/LoginForm';

const LoginPage = () => {
  return (
    <AuthLayout heading="Welcome back">
      <LoginForm />
    </AuthLayout>
  );
};

export default LoginPage;
